/** What a prospect's business does, as the quote form asks it; the codes are the backend's QuoteBusinessType. */
export const quoteBusinessTypes: ReadonlyArray<readonly [code: string, label: string]> = [
  ['GROCERY', 'Abarrotes'],
  ['AGRICULTURE', 'Agrícola'],
  ['CRAFTS', 'Artesanías'],
  ['CAR_WASH', 'Autolavado'],
  ['BAR', 'Bar'],
  ['CLOTHING', 'Boutique y ropa'],
  ['CAFE', 'Cafetería'],
  ['BUTCHER', 'Carnicería y pollería'],
  ['PAWNSHOP', 'Casa de empeño'],
  ['MEDICAL_OFFICE', 'Consultorio'],
  ['WHOLESALE', 'Distribuidora y mayoreo'],
  ['CANDY', 'Dulcería'],
  ['ELECTRONICS', 'Electrónica y celulares'],
  ['SCHOOL', 'Escuela'],
  ['BEAUTY', 'Estética y barbería'],
  ['PHARMACY', 'Farmacia'],
  ['HARDWARE', 'Ferretería y tlapalería'],
  ['FLORIST', 'Florería'],
  ['PRODUCE', 'Frutas y verduras'],
  ['LIVESTOCK', 'Ganadería'],
  ['GYM', 'Gimnasio'],
  ['HOTEL', 'Hotel'],
  ['JEWELRY', 'Joyería'],
  ['TOYS', 'Juguetería'],
  ['LAUNDRY', 'Lavandería'],
  ['LIQUOR', 'Licorería y vinos'],
  ['BUILDING_MATERIALS', 'Materiales para construcción'],
  ['MINIMARKET', 'Minisúper'],
  ['FURNITURE', 'Mueblería'],
  ['OPTICIAN', 'Óptica'],
  ['BAKERY', 'Panadería'],
  ['STATIONERY', 'Papelería'],
  ['ICE_CREAM', 'Paletería y nevería'],
  ['MANUFACTURING', 'Producción y manufactura'],
  ['WATER', 'Purificadora de agua'],
  ['AUTO_PARTS', 'Refaccionaria'],
  ['GIFTS', 'Regalos y novedades'],
  ['RESTAURANT', 'Restaurante'],
  ['SPA', 'Spa'],
  ['SERVICE_SHOP', 'Taller de servicio'],
  ['MECHANIC', 'Taller mecánico'],
  ['TORTILLERIA', 'Tortillería'],
  ['VETERINARY', 'Veterinaria'],
  ['SHOES', 'Zapatería'],
  ['OTHER', 'Otro giro'],
]
